// Marketing-tab queries (V2 redesign).
// Hero-row queries live in `statusLogs.graphql.tsx` for legacy reasons; new
// per-tab metric queries live alongside their tab's components in this file.

export const GET_PIPELINE_SOURCE_BREAKDOWN = gql`
  query GetPipelineSourceBreakdown($filters: StatusLogFiltersInput) {
    pipelineSourceBreakdown(filters: $filters) {
      source
      leads
      hires
      conversionRate
      avgDaysToHire
      cohortHires
      cohortConversionRate
      cohortAgentBookedHires
      cohortAgentBookedRate
      # Marketing budget for this source in both forms, plus its derived costs.
      # totalBudget is what was entered for the months the window touches;
      # proratedBudget is the share inside the window, and what the cost ratios
      # divide. Null
      # when no budget line targets the source, or when recruiter/job filters
      # make company-wide spend unsliceable.
      totalBudget
      proratedBudget
      costPerLead
      costPerHire
      # Whether a per-link-name drill-down exists for this source. The rows
      # themselves load on demand via GET_PIPELINE_SOURCE_NAME_BREAKDOWN.
      hasNameBreakdown
    }
  }
`

// Per-link-name rows for one source, fetched when the user expands it in the
// "Pipeline by Source" table — keeps the default page load cheap.
export const GET_PIPELINE_SOURCE_NAME_BREAKDOWN = gql`
  query GetPipelineSourceNameBreakdown(
    $source: LinkType!
    $filters: StatusLogFiltersInput
  ) {
    pipelineSourceNameBreakdown(source: $source, filters: $filters) {
      source
      linkName
      leads
      hires
      conversionRate
      avgDaysToHire
      cohortHires
      cohortConversionRate
      cohortAgentBookedHires
      cohortAgentBookedRate
      totalBudget
      proratedBudget
      costPerLead
      costPerHire
    }
  }
`

export const GET_PIPELINE_LEADS_BY_PERIOD = gql`
  query GetPipelineLeadsByPeriod($input: PipelineLeadsByPeriodInput!) {
    pipelineLeadsByPeriod(input: $input) {
      bucket
      periods
      cells {
        source
        periodStart
        count
      }
    }
  }
`

export const GET_PIPELINE_SUMMARY = gql`
  query GetPipelineSummary($input: PipelineSummaryInput!) {
    pipelineSummary(input: $input) {
      counts {
        stage
        count
      }
      total
    }
  }
`

export const GET_PIPELINE_ACTIVITY = gql`
  query GetPipelineActivity($input: PipelineActivityInput!) {
    pipelineActivity(input: $input) {
      bucket
      series {
        stage
        points {
          periodStart
          count
        }
      }
    }
  }
`

export const GET_EMPLOYEE_LEADERBOARD = gql`
  query GetEmployeeLeaderboard($input: EmployeePerformanceLeaderboardInput!) {
    employeePerformanceLeaderboard(input: $input) {
      employeeId
      employee {
        employeeId
        firstName
        lastName
      }
      leads
      hires
      conversionRate
      avgDaysToHire
      retention90d
      activeCount
      cohortHires
      cohortConversionRate
    }
  }
`

export const GET_EMPLOYEE_FUNNELS = gql`
  query GetEmployeeFunnels($input: EmployeeFunnelsInput!) {
    employeeFunnels(input: $input) {
      employeeId
      employee {
        employeeId
        firstName
        lastName
        jobTitle
        coverImage
      }
      total
      stages {
        stage
        count
      }
    }
  }
`

export const GET_PIPELINE_OUTCOMES = gql`
  query GetPipelineOutcomes($input: PipelineOutcomesInput!) {
    pipelineOutcomes(input: $input) {
      rows {
        source
        leadCount
        hiredCount
        notInterestedCount
        disqualifiedCount
      }
      notInterestedReasons {
        source
        reason
        count
      }
      disqualifiedReasons {
        source
        reason
        count
      }
    }
  }
`

export const GET_PIPELINE_STAGES_BY_JOB_LISTING = gql`
  query GetPipelineStagesByJobListing(
    $input: PipelineStagesByJobListingInput!
  ) {
    pipelineStagesByJobListing(input: $input) {
      jobListingId
      jobListing {
        jobListingId
        title
        status
      }
      total
      stages {
        stage
        count
      }
    }
  }
`
